import React, { useState} from 'react';
import * as S from "../Main/informacoes_tecnicas_style.jsx"
import Footer from "../Footer/footerHome.jsx"
import TabDecor from "./tabs/tabsDecor.jsx"
import TabLinea from "./tabs/tabsLinea.jsx"
import Tab16Faces from "./tabs/tabs16Faces.jsx"
import TabMeioFio from "./tabs/tabsMeioFio.jsx"

export default function InformacoesTecnicas() {
    const [activeTab, setActiveTab] = useState("linea")

    const tab1 = () => {
        setActiveTab("linea")
    }
    const tab2 = () => {
        setActiveTab("16faces")
    }
    const tab3 = () => {
        setActiveTab("decor")
    }
    const tab4 = () => {
        setActiveTab("meiofio")
    }

    return (
        <>
            <S.Main>
                <S.DivTitulo>
                    <h1>Produtos</h1>
                    <h2>Informações técnicas sobre pisos intertravados</h2>
                </S.DivTitulo>
                <S.SectionEspecificacoes>
                    <h2>Produtos</h2>
                    <S.DivTabs>
                        <button onClick={tab1} className={activeTab === "linea" ? "active" : ""}>Linea</button>
                        <button onClick={tab2} className={activeTab === "16faces" ? "active" : ""}>16 Faces</button>
                        <button onClick={tab3} className={activeTab === "decor" ? "active" : ""}>Decor</button>
                        <button onClick={tab4} className={activeTab === "meiofio" ? "active" : ""}>Meio Fio</button>
                    </S.DivTabs>
                    <div>
                        {activeTab === "linea" ? <TabLinea /> : ""}
                    </div>
                    <div>
                        {activeTab === "16faces" ? <Tab16Faces /> : ""}
                    </div>
                    <div>
                        {activeTab === "decor" ? <TabDecor /> : ""}
                    </div>
                    <div>
                        {activeTab === "meiofio" ? <TabMeioFio /> : ""}
                    </div>
                </S.SectionEspecificacoes>
                <S.SectionInfoAdicional>
                    <h2>Informações adicionais</h2>
                    <S.SectionTextoAdicional>
                        <div>
                            <h3>Variação de Cor</h3>
                            <p>As variações de cores podem ocorrer nos produtos de concreto devido a leve variação nos lotes de pigmentos e materiais básicos.</p>
                            <p>A apresentação no site pode conter alterações em virtude das configurações de cada monitor.</p>
                            <p><strong>Outras opções de cores dos pisos intertravados são disponiveis sob encomenda.</strong></p>
                        </div>
                        <S.TextoTravamento>
                            <h3>Travamento dos pisos intertravados</h3> 
                            <p>A pavimentação é necessario o travamento dos pisos intertravados em todo o seu perimetro(lados) usando para tal: meio fios, tentos ou paredes existentes.</p>
                        </S.TextoTravamento>
                    </S.SectionTextoAdicional>
                    
                </S.SectionInfoAdicional>
                <S.SectionPerguntas>
                    <h2>Perguntas Técnicas</h2>
                    <S.PerguntaResposta>
                        <S.Pergunta>Qual a espessura ideal do piso intertravado para cada tipo de aplicação?</S.Pergunta>
                        <S.PerguntaSubtitulo>
                            A espessura do piso intertravado deve ser definida de acordo com o tipo de tráfego previsto:
                        </S.PerguntaSubtitulo>
                        <p>6cm: Indicado para pedestres, ciclovias, veículos leves e caminhões até dois eixos</p>
                        <p>8cm: Indicado para veículos pesados a partir de três eixos</p>
                        <p>10cm: Indicado para veículos especiais e portos de aeroportos (acima de 40.000 KGf)</p>
                    </S.PerguntaResposta>
                    <S.PerguntaResposta2>
                        <S.Pergunta>Existe o melhor tipo de piso intertravado?</S.Pergunta>
                        <S.TextoPergunta2>O melhor tipo de piso intertravado varia conforme a aplicação.
                            Cada modelo possui características próprias de resistência e acabamento, indicadas para diferentes finalidades, como áreas residenciais, comerciais ou de alto tráfego.</S.TextoPergunta2>
                            <p><strong>Obs: A resistência da pavimentação está ligada a preparação da base, não necessariamente a resistência do piso</strong></p>
                    </S.PerguntaResposta2>
                </S.SectionPerguntas>
            </S.Main>
            <Footer />
        </>
    )
}